export const INPUT_WHITESPACES_REGEX = /\s+/g;
